// import { r2PaletteColors } from '../layout/themes'
// import indigo from '@material-ui/core/colors/indigo';
// import blue from '@material-ui/core/colors/blue';

export const getOffersStatuses = () => [
    { id: "100", name: "100 - New Offer" },
    { id: "101", name: "101 - In Partner Review" },
    { id: "102", name: "102 - Rejected by Partner" },
    { id: "103", name: "103 - Approved by Partner" },
    { id: "104", name: "104 - Available" },
    { id: "105", name: "105 - KYC: In Review" },
    { id: "1061", name: "1061 - KYC Returned: Expired ID" },
    { id: "1062", name: "1062 - KYC Returned: Expired Proof of Address" },
    { id: "1063", name: "1063 - KYC Returned: ID Not Legible/Readable" },
    { id: "1064", name: "1064 - KYC Returned: Proof of Address Not Legible/Readable" },
    { id: "1065", name: "1065 - KYC Returned: Invalid ID" },
    { id: "1066", name: "1066 - KYC Returned: Invalid Proof of Address" },
    { id: "1067", name: "1067 - KYC Returned: Expired ID and Expired Proof of address" },
    { id: "1068", name: "1068 - KYC Returned: Expired ID and ID not legible" },
    { id: "1069", name: "1069 - KYC Returned: Expired ID and Proof of address not legible" },
    { id: "10610", name: "10610 - KYC Returned: Expired Proof of address and ID not legible" },
    { id: "10611", name: "10611 - KYC Returned: Expired Proof of address and Proof of address not legible" },
    { id: "10612", name: "10612 - KYC Returned: Expired Proof of address and ID not valid" },
    { id: "10613", name: "10613 - KYC Returned: ID not legible and Proof of address not legible" },
    { id: "10614", name: "10614 - KYC Returned: ID not legible and ID not valid" },
    { id: "10615", name: "10615 - KYC Returned: ID not legible and Proof of Address not valid" },
    { id: "10616", name: "10616 - KYC Returned: Proof of address not legible and ID not valid" },
    { id: "10617", name: "10617 - KYC Returned: Proof of address not legible and Proof of Address not valid" },
    { id: "107", name: "107 - Approved" },
    { id: "108", name: "108 - Not Approved" },
    { id: "1091", name: "1091 - Canceled: Documents Not Received" },
    { id: "1092", name: "1092 - Canceled: Risk Prevention (Credit History)" },
    { id: "1093", name: "1093 - Canceled: Risk Prevention (Fraud Prevention)" },
    { id: "1094", name: "1094 - Canceled: Contract Not Signed" },
    { id: "1095", name: "1095 - Canceled: Other" },
    { id: "110", name: "110 - Signature Pending" },
    { id: "111", name: "111 - Signed" },
    { id: "112", name: "112 - Disbursement Sent" },
    { id: "113", name: "113 - Disbursement Failed" },
    { id: "114", name: "114 - Disbursed" },
]